// convertUrlToSafariScheme.js
'use strict';

/**
 * Convert URL to Safari custom scheme (x-safari-https:// or x-safari-http://)
 * This is used for MDM (Mobile Device Management) deep linking to Safari
 * @param {string} url - The URL to convert
 * @return {string} The converted URL with x-safari-https:// or x-safari-http:// scheme
 */
const convertUrlToSafariScheme = url => {
  try {
    const newUrl = new URL(url);
    return `x-safari-${newUrl.href}`;
  } catch (error) {
    // try to fix input url if it is not a valid url
    if (/^https?:\/\//i.test(url)) {
      return url
        .replace(/^https:/, 'x-safari-https:')
        .replace(/^http:/, 'x-safari-http:');
    }
    return url;
  }
};

export default convertUrlToSafariScheme;
